{
  "es": {
    "empty": {
      "headlines": {
        "default": "There's nothing to see here...",
        "forName": "No se encontró %{name}",
        "hangar": "Su hangar está vacío",
        "wishlist": "Su lista de deseos está vacía",
        "features": "No hay funciones disponibles",
        "fleetFeatures": "No hay funciones de flota disponibles",
        "imports": "No se encontraron importaciones",
        "transfers": "Aún no hay transferencias"
      },
      "actions": {
        "reset": "Reset Filters/Pages",
        "resetPage": "Go to First Page"
      },
      "texts": {
        "info": "No pudimos encontrar ningún registro.",
        "query": "It seems like you have some Filters active or visited a Page without any Records."
      },
      "info": {
        "hangar": "You can add Ships to your Hangar by clicking on the bookmark icon in the top right corner of a Ship or by using the Plus Button in the bottom right corner.",
        "extension": "Additionally you can import your Hangar from the RSI Website via the Fleetyards Sync Browser extension.",
        "wishlist": "You can add Ships to your Wishlist by clicking on the bookmark icon in the top right corner of a Ship.",
        "features": "Actualmente no hay funciones de autoservicio disponibles. Vuelva más tarde, ya que se agregan nuevas funciones regularmente.",
        "fleetFeatures": "Actualmente no hay funciones que una flota pueda activar por sí misma. Vuelva más tarde, ya que se agregan nuevas funciones regularmente."
      },
      "payouts": {
        "entries": "Nada registrado todavía",
        "participants": "Nadie en esta expedición todavía",
        "transfers": "Liquida para ver quién paga a quién",
        "tours": "Aún no hay expediciones"
      },
      "fleets": {
        "contracts": {
          "items": "Aún no hay mercancías. Añade lo que pide este contrato: vacío no se puede publicar."
        },
        "events": {
          "upcoming": "Nada previsto",
          "past": "Todavía no ha pasado nada",
          "archived": "Nada archivado",
          "info": {
            "upcoming": "Crea un evento para reunir a la flota: elige una fecha, añade puestos y deja que los miembros se apunten.",
            "past": "Un evento aparece aquí una vez que ha pasado su hora de finalización.",
            "archived": "Archivar quita un evento de la lista sin borrarlo."
          }
        },
        "missions": {
          "active": "Aún no hay misiones",
          "archived": "Nada archivado",
          "info": {
            "active": "Una misión es un plan reutilizable: equipos, naves y puestos, a partir del cual creas eventos.",
            "archived": "Archivar quita una misión de la lista sin borrarla."
          }
        },
        "squadrons": {
          "headline": "Aún no hay escuadrones",
          "info": "Los escuadrones dividen la flota en grupos, cada uno con sus propios miembros, emblema y colores. Junto a ellos están los equipos, para miembros que pertenecen a más de un grupo."
        }
      }
    }
  }
}
